// @flow
export const menuTemplates = {
    SHOP: 'SHOP'
};



// WEBPACK FOOTER //
// ./src/core/constants/menu.js